import React, { useEffect, useState } from "react";
import PageLayout from "@/layout";
import "./Core/i18n";
import { useBeforeSetting } from "./store/beforeSetting";
// import CommonEventCompoent from './components/commonEventCompoent/CommonEventCompoent';
// import WebSocketCompoent from './components/webSocket/WebSocketCompoent';
import { useGlobalState } from "./store/commonStore";

import { useTranslation } from "react-i18next";
import CommonEventCompoent from "./components/commonEventCompoent/CommonEventCompoent";
import WebSocketCompoent from "./components/webSocket/WebSocketCompoent";
import LoadingUI from "./componentsUI/LoadingUI/LoadingUI";
import { useWalletAll } from "./store/walletStore";
import {
  useLoginReminderPopup,
  usePageEntryDownloadGate,
  usePostAuthPopups,
  useOrchestratorDrain,
} from "@/features/modalOrchestrator";
import { getDynamicViewportHeight } from "@/utils/viewportHeight";

/** Data preparation before entering the interface */
const useAppEnterBefore = () => {
  const { error, data, mutate } = useBeforeSetting();
  const { mutate: walletMutate, isLoading: walletLoading } =
    useWalletAll(false);
  const { isLogin } = useGlobalState();
  const [loading, setLoading] = useState(true);

  const { ready } = useTranslation();

  // Optimization: Delay loading wallet data, do not block main flow
  useEffect(() => {
    if (isLogin && !loading) {
      // Load wallet data after main data is loaded
      walletMutate();
    }
  }, [isLogin, loading]);

  // Optimization: Reduce dependency conditions, prioritize basic data
  useEffect(() => {
    // Show interface when basic data is ready, wallet data can be loaded later
    if ((data || error) && ready) {
      setLoading(false);
    }
  }, [data, ready, error]);

  const muateFunc = () => {
    setLoading(true);
    mutate();
  };

  return {
    loading,
    error,
    data,
    mutate: muateFunc,
    walletLoading, // Expose wallet loading state for subsequent optimization
  };
};

/**
 * 需要 Redux Provider 上下文的弹窗编排 hooks。
 * 独立组件，渲染在 Provider 内部。
 */
const OrchestratorBootstrap = () => {
  useLoginReminderPopup();
  usePageEntryDownloadGate();
  usePostAuthPopups();
  useOrchestratorDrain();
  return null;
};

const App = () => {
  const { loading, error, data, mutate } = useAppEnterBefore();

  useEffect(() => {
    const startLoading = document.getElementById("start-loading");
    if (!startLoading) return;

    startLoading.classList.add("start-loading-exit");
    window.setTimeout(() => {
      startLoading.remove();
    }, 180);
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const search = {};
    urlParams.forEach((val, key) => {
      search[key] = val;
    });

    sessionStorage.setItem("search", JSON.stringify(search));
  }, []);

  return (
    <>
      <LoadingUI
        isLoading={loading}
        error={error}
        dataList={data}
        retryFunc={mutate}
        style={{ height: getDynamicViewportHeight() }}
        btnText={"Retry"}
        errorText={"Loading Error,Please Retry!"}
      >
        <OrchestratorBootstrap />
        <PageLayout />
        {/** Handle common custom events center */}
        <CommonEventCompoent />
        {/** Handle socket disconnection and connection */}
        <WebSocketCompoent />

      </LoadingUI>
    </>
  );
};
export default App;
